import { ErrorState } from '@leagueplatform/web-common-components';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

/**
 * Shown when the app could not determine whether the signed-in user is a
 * caregiver.
 *
 * Rendering the member experience instead would be wrong for the one group this
 * check exists to serve: a caregiver would land in the member app with no route
 * to their care recipients and nothing indicating a problem. An error is worse
 * for a member who is not a caregiver and better for a caregiver who is, and
 * only the error is recoverable by retrying.
 */
export const CaregiverStatusError = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      horizontalAlignment="center"
      verticalAlignment="center"
      css={{
        position: 'absolute',
        height: '100%',
        width: '100%',
      }}
    >
      <ErrorState
        headingString={formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' })}
        bodyString={formatMessage({ id: 'STR_ERROR_STATE_BODY_API' })}
        buttonText={formatMessage({ id: 'STR_RELOAD' })}
        error={null}
      />
    </StackLayout>
  );
};
